

import AboutUs from './pages/about-us';
import Home from './pages/home';
import { Routes, Route } from "react-router-dom";
import Services from './pages/services';
import SubService from './pages/sub-service';
import Blogs from './pages/blogs';
import BlogView from './pages/blog-view';
import PDFViewers from './components/sections/pdf-viewer';
import Gallery from './pages/gallery';
import ContactUs from './pages/contact-us';
import Faq from './pages/faq';
import Careers from './pages/careers';
import PricingPlans from './pages/pricing-plans';
import VaastuHousePlans from './pages/vaastu-house-plans';
import TermsAndConditions from './pages/terms-and-conditions';
import ScrollToTop from './components/scroll-to-top';
import CustomerLogin from './pages/customer-login';
import CustomerDashboard from './pages/customer-dashboard';
import CustomerProjectPlanner from './pages/customer-project-planner';
import CustomerResetPassword from './pages/customer-reset-password';
import NotFound from './pages/not-found';
import ProtectedRoute from './components/customer/ProtectedRoute';
// PDF Viewer Implementation
import { pdfjs } from 'react-pdf';
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.js',
  import.meta.url,
).toString();

function App() {
  return (
    <>
     {/* Scroll to top when route changes */}
     <ScrollToTop />
       <Routes>
      {/* <Route path="/" element={<Layout />}> */}
      <Route path="/" element={<Home />} />
      <Route path="/home" element={<Home />} />
      <Route path="/about-us" element={<AboutUs />} />
      <Route path="/services" element={<Services />} />
      <Route path="/services/:slug" element={<SubService />} />
      <Route path="/blogs" element={<Blogs />} />
       <Route path="/blog-view/:slug" element={<BlogView />} />
      <Route path="/portfolio" element={<Gallery />} />
      <Route path="/faq" element={<Faq />} />
      <Route path="/contact-us" element={<ContactUs />} />
      
      <Route path="/careers" element={<Careers />} />
      <Route path="/sub-service" element={<SubService />} />
      <Route path="/pdf-viewer" element={<PDFViewers />} />
      <Route path="/our-pricing" element={<PricingPlans />} />
      <Route path="/vaastu-house-plans" element={<VaastuHousePlans />} />
      <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
      
      {/* Customer Portal Routes - Hidden paths */}
      <Route path="/customer/login" element={<CustomerLogin />} />
      <Route 
        path="/customer/reset-password/:token/:email" 
        element={<CustomerResetPassword />} 
      />
      <Route 
        path="/customer/dashboard" 
        element={
          <ProtectedRoute>
            <CustomerDashboard />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/customer/project-planner/:project_id" 
        element={
          <ProtectedRoute>
            <CustomerProjectPlanner />
          </ProtectedRoute>
        } 
      />
      
      {/* 404 Not Found Page */}
      <Route path="/404" element={<NotFound />} />
      
      {/* Catch-all route - shows 404 page for unmatched routes */}
      <Route path="*" element={<NotFound />} />
    </Routes>
    </>
  
  );
}

export default App;
